import { useCurrentWorkspace } from "hooks/useCurrentWorkspace"
import { Tone, ToneSelect } from "./ToneSelect"
import { VoiceSelect } from './VoiceSelect'
import { useBrandVoices } from "hooks/useBrandVoices"
import { useEffect, useMemo, useState } from "react"
import { Button } from "components/Button/Button"
import Styles from './ToneSelect.module.scss'

export const MAX_INITIAL_PILLS = 5

interface Props {
  className?: string
  onVoicesChange: (voice?: number) => void
  onTonesChange: (tones: Array<Tone>) => void
  selectedTones: Array<Tone>
  selectedVoice?: number
  isVoicesInline?: boolean
  isTonesInline?: boolean
}

export const VoicesAndTonesSelect = ({
  className,
  onVoicesChange,
  onTonesChange,
  selectedVoice,
  selectedTones,
  isVoicesInline = false,
  isTonesInline = false,
}: Props) => {
  const currentWorkspace = useCurrentWorkspace()
  const voicesQuery = useBrandVoices(currentWorkspace)
  const voices = useMemo(() => voicesQuery.data ?? [], [voicesQuery])
  const [showAll, setShowAll] = useState(false)

  const someAndLessThanMaxVoices = voices.length > 0 && voices.length <= MAX_INITIAL_PILLS
  const moreThanMaxVoices = voices.length > MAX_INITIAL_PILLS

  useEffect(() => {
    const latestVoice = voices[voices.length - 1]?.id

    if (voicesQuery.isFetched && latestVoice) {
      onVoicesChange(latestVoice)
    }
  }, [voices]) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className={className}>
      <VoiceSelect
        inline={isVoicesInline}
        selectedVoice={selectedVoice}
        onChange={onVoicesChange}
        voices={voices.slice().reverse()}
        showAll={showAll}
      />
      {(showAll || (voicesQuery.isFetched && !voices.length)) && <ToneSelect inline={isTonesInline} selectedTones={selectedTones} onChange={onTonesChange} />}
      {!showAll && (moreThanMaxVoices || someAndLessThanMaxVoices) && (
        <Button className={Styles.moreButton} variant="tertiary" size="md" onPress={() => setShowAll(true)}>
          More...
        </Button>
      )}
    </div>
  )
}
